<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
        </v-overlay>

      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true">
              {{ $t("show_qr") }}
            </v-tab>

            <v-tab :ripple="true"> {{ $t("preview") }} </v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>

          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 10px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <div class="d-flex flex-column justify-center align-center">
                <qr-maker :loading="loading" />
                <div class="rowinfo">
                  <v-btn class="btn-download" @click="showDialog = true">
                    <v-icon>mdi-progress-download</v-icon>
                    {{ $t("download_qr") }}                  </v-btn>
                  <help-info
                    :element-name="`${serviceName}-${componentName}-download`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="دانلود کیوآر"
                  />
                </div>
              </div>
            </v-tab-item>

            <v-tab-item>
              <catalog-show
                v-if="cardTexts"
                v-model="cardTexts"
                :orders.sync="orders"
                :theme="catalogType"
                :qr-svg-data-url="qrSvgDataUrl"

              />
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
                <Tariffs :id_qr="info.id" :qrtype="'catalog'" />
             </v-tab-item>


          </v-tabs-items>
        </v-col>

        <v-col cols="12" md="8">
          <template>
            <v-stepper v-model="e6" class="px-0 mx-0" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p>وارد کردن اطلاعات کاتالوگ / بروشور</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0 rowinfo">
                    <v-text-field
                      v-model="cardTexts.visitName"
                      :disabled="e6 > 1"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام کاتالوگ / بروشور شما"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="نام کاتالوک"
                    />
                  </div>
                  <div class="col-md-6 mt-0 pt-0 rowinfo">
                    <qr-address-field
                      id="qr-address"
                      ref="address-field"
                      v-model="dtUrl"
                      :disabled="e6 > 1"
                      :error-messages="errors['identifier']"
                      append-icon="mdi-web"
                      class="mt-0 pt-0 contentinfo"
                      dense
                      outlined
                      persistent-hint
                      @updateDest="domainId = $event"
                      :key="$t('qrAddressUpdate.hints.allowedChars')"
                      :hint="$t('qrAddressUpdate.hints.allowedChars')"

                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-dtUrl`"
                      label="آدرس کیوآر"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                    />
                  </div>
                </div>
              </v-stepper-step>

              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="markQr(false)"
                  />
                </div>
              </v-stepper-content>

              <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2"
                >تنظیمات کیوآر</v-stepper-step
              >

              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                <div class="mb-4">
                      <!-- سوییچ و آیکون راهنما -->
                      <div class="d-flex align-center">
                        <v-switch
                          v-model="AutoSave"
                          color="primary"
                          class="mt-0 pt-0 shrink"
                          hide-details
                          label="ذخیره خودکار"
                        ></v-switch>

                        <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                        <v-tooltip bottom max-width="320">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              class="mr-1"
                              v-bind="attrs"
                              v-on="on"
                              @click.stop
                            >
                              <v-icon small color="grey darken-1">
                                mdi-help-circle-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>
                            تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                          </span>
                        </v-tooltip>
                      </div>

                      <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                      <div
                        v-if="$vuetify.breakpoint.xsOnly"
                        class="text-caption grey--text text--darken-1 mt-1 pr-1"
                        style="line-height: 1.4"
                      >
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </div>
                    </div>


                <list-expansion
                  flat
                  icon="pencil-ruler"
                  single
                  title="انتخاب نوع نمایش"
                  :service-name="serviceName"
                  :component-name="componentName"
                  @save-required="AutoSave && qrUpdate(false)"

                >
                  <template v-slot:content>
                    <catalog-types
                      v-model="catalogType"
                      :components="catTypes"
                    />
                  </template>
                </list-expansion>
                <list-expansion
                  v-model="cardTexts"
                  :components="specialInfo"
                  :data="cardTexts"
                  :service-name="serviceName"
                  :component-name="componentName"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"

                />

                <div class="row mx-auto">
                  <div class="col-md-6">
                    <prev-btn :loading="loading" @click="e6 = 1" />
                  </div>

                  <div class="col-md-6">
                    <next-btn :loading="loading" @click="qrUpdate(true)" />
                  </div>
                </div>
              </v-stepper-content>
            </v-stepper>
          </template>
          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>
        </v-col>
        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>
          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
              :visit-name="cardTexts.visitName"
              @close="showDialog = false"
              :qr_id="info.qrId"

            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { setDragging } from "@/utilities/DraggingKeysOrder";
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import NextBtn from "@/view/content/fragments/nextBtn";
import ListExpansion from "@/view/content/fragments/listExpansion";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PicSelector from "@/view/components/UploadCenter/picSelector";
import { Bus, debounce } from "@/main";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import TurnViewer from "@/view/pages/otherQrTypes/leafletCatalog/components/turnViewer";
import { mapState, mapActions } from "vuex";
import Tariffs from "../../../components/Tariffs/Tariffs.vue";

const baseInfo = () => import("/src/view/components/otherBase/baseInfo");
const socialMediaIcons = () =>
  import("@/view/pages/qrland/components/socialMediaIcons");
const imageUploader = () =>
  import("@/view/pages/qrland/components/imageUploader");
const bannerSelector = () =>
  import("@/view/components/UploadCenter/bannerSelector");
import catalogTypes from "@/view/pages/otherQrTypes/leafletCatalog/components/catalogTypes.vue";
import CatalogShow from "@/view/pages/otherQrTypes/leafletCatalog/components/CatalogShow";
import textCards from "@/view/pages/qrland/components/textCards";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "create",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    CatalogShow,
    TurnViewer,
    // CatalogView,
    DownloadFileWithApi,
    QrCodeMake,
    QrMaker,
    catalogTypes,
    QrManagement,
    PrevBtn,
    QrCustomize,
    QrAddressField,
    ListExpansion,
    NextBtn,
    PicSelector,
    Tariffs,
    AtomSpinner
  },

  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,
      qrSvgDataUrl: "",
      orders: [
        { name: "userName" },
        { name: "aboutUs" },
        // { name: "textCards" },
        // { name: "PicSelector" },
        // { name: "gallery" },
        // { name: "photo" },
        // { name: "video_gallery" },
        { name: "extraFields" },
        { name: "phoneNumber" },
        { name: "fax" },
        { name: "location" },
        { name: "codePostal" },
        { name: "email" },
        { name: "website" },
        // { name: "socialMedia" },
      ],
      helpData: [],
      serviceName: "Qrland",
      componentName: "leafletcatalogcreate",
      e6: 1,
      qrShow: 1,
      info: null,
      svgMade: "",
      destinationUrl: "",
      imageMade: "",
      createdDomain: "",
      createdId: null,
      dtUrl: null,
      shortId: null,
      domainId: null,
      showDialog: false,
      loading: false,
      finish: true,
      errors: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      cardTexts: {
        PicSelector: {
          title: "گالری عکس",
          description: "کالری عکس کاتالوگ",
          sectionColor: {
            backGround: "linear-gradient(to bottom , #C22121FF, #130000FF)",
            text: "#fff",
          },
          slider: true,
        },
        textCards: {
          sectionColor: {
            backGround: "linear-gradient(to bottom , #C22121FF, #130000FF)",
            text: "#fff",
          },
        },
        tab_design: 1,

        userName: "کیوآر لند",
        workField: "داینامیک",
        aboutUs:
          'باتوجه به مشکلات موجود در کارت ویزیت فیزیکی\nسامانه کیوآر لند محصولی به نام "کارت ویزیت الکترونیکی"\nرا ارائه نموده است.\nو با استفاده از تکنولوژی های دیجیتالی\nتوانسته مشکلات و محدودیت های موجود در\nکارت ویزیت های فیزیکی را به طور کامل برطرف نماید.\nهمزمان، با جایگزین کردن هوشمندی، از قطع بی رویه درختان جلوگیری کنید.',
        video_single: {
          name: "",
          videos: [],
        },
        photo: {
          profile: "https://cdn.terminalads.com/upload/64b11ae97aae0.webp",
          transition: "scale",
          hasWelcome: false,
          headBackground: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
          gallery: [
            {
              name: "ما همیشه کنار شما خواهیم ماند...",
              images: [
                {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_possibilities",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af06f647f05.webp",
                  description: "",
                  link: "",
                  id: 1147899,
                },
                {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_possibilities",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
                  description: "",
                  link: "",
                  id: 1147900,
                },
                {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_features_of_clearer_QR_code",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af07463ae3d.webp",
                  description: "",
                  link: "",
                  id: 1147902,
                },
                {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_features_of_clearer_QR_code",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af072f1425c.webp",
                  description: "",
                  link: "",
                  id: 1147901,
                },
              ],
            },
          ],
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        video_gallery: [
          {
            name: "",
            images: [
              {
                name: "چرا کارت ویزیت کیو آر لند؟ کیو آر لند با بقیه چه فرقی داره؟",
                title: "چرا کارت ویزیت کیوآر لند",
                file_link:
                  "https://www.aparat.com/video/video/embed/videohash/okn5zhp/vt/frame",
                description: "",
                link: "",
                id: 456,
              },
              {
                name: "معرفی کارت ویزیت الکترنیکی کیوآر لند",
                title: "بهترین جایگزین کارت ویزیت فیزیکی",
                file_link:
                  "https://www.aparat.com/video/video/embed/videohash/zmyd3vb/vt/frame",
                description: "",
                link: "",
                id: 267,
              },
            ],
          },
        ],
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        phoneNumber: [
          {
            number: "90007425",
          },
        ],
        fax: "02191016066",
        location:
          "تهران، خیابان شریعتی ، بعد از پل سید خندان، بن بست خندان ، پلاک 6 ",
        codePostal: "1541946815",
        email: "info@qrland.ir",
        website: "www.qrland.ir",
        visitName: "کاتالوگ",
        pallete: {
          headColor: "linear-gradient(to top, #AA7630FF, #EBCB63FF)",
          bodyColor: "linear-gradient(to top right , #AA7630FF, #EBCB63FF)",
          textColor: "#ffffff",
          borderColor: "#393939",
          isDarkBody: false,
        },
        isGradient: true,
        organizationName: "سامانه کیوآر لند",
        subOrgan: "اولین سامانه ساخت کیوآر کد داینامیک",
        companyNumber: "02191017077",
        city: "",
        province: "",
        country: "",
        gallery: [
          {
            name: "کاتالوگ",
            images: [
              {
                title: "alla_berger-wallpaper-1600x900",
                url: "",
                description: "",
                link: "",
              },
              {
                title: "shrug",
                url: "",
                description: "",
                link: "",
              },
              {
                title: "",
                url: "https://cdn.terminalads.com/upload/67af06f647f05.webp",
                description: "",
                link: "",
              },
              {
                title: "",
                url: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
                description: "",
                link: "",
              },
              {
                title: "",
                url: "https://cdn.terminalads.com/upload/67af07463ae3d.webp",
                description: "",
                link: "",
              },
              {
                title: "",
                url: "https://cdn.terminalads.com/upload/67af072f1425c.webp",
                description: "",
                link: "",
              },
            ],
          },
        ],
        socialMedia: {
          address: [
            {
              hint: " لطفا آدرس آدرس خودرا وارد کنید ",
              label: "آدرس",
              url: "www.qrland.ir",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
              prefix: "URL",
              pattern: "",
            },
            {
              hint: " لطفا آدرس آدرس خودرا وارد کنید ",
              label: "آدرس",
              url: "www.qr.terminalads.com",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
              prefix: "URL",
              pattern: "",
            },
          ],
          instagram: [
            {
              hint: " لطفا آدرس اینستاگرام خودرا وارد کنید ",
              label: "اینستاگرام",
              url: "https://instagram.com/terminalads",
              img: "/media/socialIcon/40icon/instagram.svg",
              svg: "svgInstagram",
              prefix: "@",
              pattern: "https://instagram.com/",
            },
          ],
          whatsapp: [
            {
              hint: " لطفا آدرس واتساپ خودرا وارد کنید ",
              label: "واتساپ",
              url: "+982191017077",
              img: "/media/socialIcon/40icon/whatsapp.svg",
              svg: "svgWhatsapp",
              prefix: "mdi-phone",
              pattern: "https://wa.me/",
            },
          ],
        },
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      specialInfo: [
        {
          name: "textCards",
          value: "",
          title: "اطلاعات",
          icon: "account-outline",
        },
        {
          name: "imageUploader",
          value: "",
          title: "آپلود لوگو",
          icon: "image",
          model: "photo",
        },
        {
          name: "PicSelector",
          value: "",
          title: "آپلود تصاویر کاتالوگ / بروشور",
          icon: "image",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ],
      catTypes: [
        { name: "turning", title: "ورق زدن" },
        { name: "slide", title: "اسلایدر" },
        { name: "vertical", title: "عمودی" },
      ],
      catalogType: "turning",
    };
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    ...mapActions("local", [
      "updateQrId",
      "updateQridentifier",
      "updateQrInfo",
      "updateQrDomain",
    ]),
    setKeys(val = this.cardTexts) {
      let keys = setDragging(val, this.orders);
      keys = keys.filter(
        (item) =>
          item.name !== "pallete" &&
          item.name !== "apiKey" &&
          item.name !== "center" &&
          item.name !== "coordinates",
      );

      this.orders = keys;
      this.$forceUpdate();
    },

    markQr(final = false) {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "catalog",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: this.catalogType,
          data: this.cardTexts,
          orders: this.orders,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.createdId = data.data.identifier;
          this.info = data.data;
          this.qrShow = 0;
          this.$toast.success("کیوار کاتالوگ شما با موفقیت ساخته شد.");
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate(false);
                this.qrShow = 1;
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    preview(link) {
      this.loading = true;
      this.$api
        .post("/v1/Qr/preview", this.getQrDesign)
        .then(({ data }) => {
          this.loading = false;
          this.imageMade = null;
          this.svgMade = data.data;
        })
        .catch((err) => {
          this.loading = false;
          // this.$toast.error('خطای سرور!')
        })
        .finally(() => {
          this.loading = false;
        });
    },
  qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "catalog");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append("qr_id", this.info.qrId);

      data.append(
        "data",
        JSON.stringify({
          theme: this.catalogType,
          data: this.cardTexts,
          orders: this.orders,
        }),
      );
      let finaldata = {
        theme: this.catalogType,
        data: this.cardTexts,
        orders: this.orders,
      };
      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then(({ data }) => {
          if (final) {
            this.info = data.data;
            this.qrShow = 0;
            this.goto("qr/list");
          }
        })
        .catch((err) => {})
        .finally(() => {
          if (final) {
            this.goto("qr/list");
            this.qrShow = 0;
          }
          this.loading = false;
          this.isAutoSaving = false;
        });
    },

    clearDefaults() {
      this.$root.$emit("clearDefaultData");

      this.cardTexts.visitName = "";
      this.cardTexts.isGradient = false;
      this.cardTexts.organizationName = "";
      this.cardTexts.subOrgan = "";
      this.cardTexts.userName = "";
      this.cardTexts.workField = "";

      this.cardTexts.phoneNumber = [{ number: "" }];

      this.cardTexts.extraFields = [
        {
          icon: "",
          name: "",
          value: "",
        },
      ];

      this.cardTexts.companyNumber = "";
      this.cardTexts.email = "";
      this.cardTexts.fax = "";
      this.cardTexts.location = "";
      this.cardTexts.city = "";
      this.cardTexts.codePostal = "";
      this.cardTexts.province = "";
      this.cardTexts.country = "";
      this.cardTexts.website = "";
      this.cardTexts.socialMedia = {};
      this.cardTexts.aboutUs = "";

      this.cardTexts.photo.gallery = null;
      this.cardTexts.photo.transition = "scale";
      this.cardTexts.photo.hasWelcome = false;
      this.cardTexts.photo.previewerQr.previewer.gif = "";
      this.cardTexts.photo.previewerQr.previewer.game = null;

      this.cardTexts.video_single = {
        name: "",
        videos: [],
      };

      this.cardTexts.center = [51.420296, 35.732379];
      this.cardTexts.coordinates = [null, null];
      this.cardTexts.address = "";

      this.cardTexts.apiKey =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg";

      this.cardTexts.textCards.contactNumber = "";
      this.cardTexts.textCards.address = "";
      this.cardTexts.textCards.sectionColor = {
        backGround: "linear-gradient(to bottom , #C22121FF, #130000FF)",
        text: "#fff",
      };
    },
  },

  watch: {
    cardTexts: {
      deep: true,
      handler(newVal) {
        debounce(() => {
          this.setKeys(newVal);
        }, 300);
      },
    },
    qrDesign: {
      handler() {
        if (this.destinationUrl) {
          debounce(() => {
            this.preview(this.destinationUrl);
          }, 2000);
        }
      },
      deep: true,
    },
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },
  computed: {
    ...mapState("local", ["qr_id"]),
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
    imageurl_1() {
      return this.$cdnUrl + "/upload/6485f57221bc9.webp";
    },
    imageurl_2() {
      return this.$cdnUrl + "/upload/6485f5743d1c7.webp";
    },
    getQrDesign() {
      return {
        section: "#link",
        link: this.destinationUrl,
        backcolor: !this.qrDesign.qrStyleColors?.backcolor
          ? "#ffffff"
          : this.qrDesign.qrStyleColors?.backcolor,
        gradient_color: !this.qrDesign.qrStyleColors?.gradient_color
          ? "#8900d5"
          : this.qrDesign.qrStyleColors?.gradient_color,
        frontcolor: !this.qrDesign.qrStyleColors?.frontColor
          ? "#000000"
          : this.qrDesign.qrStyleColors?.frontColor,
        gradient: this.qrDesign.qrStyleColors?.gradient ? "on" : "",
        pattern: this.qrDesign.qrStyleColors.pattern,
        marker_in: this.qrDesign.MarkerCenter.eyePattern,
        marker_in_color: this.qrDesign.MarkerCenter.main,
        markers_color: this.qrDesign.MarkerCenter.different_markers_color
          ? "on"
          : "",
        marker: this.qrDesign.QrMarkOut.markOutPattern,
        different_markers_color:
          this.qrDesign.QrMarkOut.different_markers_color ||
          this.qrDesign.MarkerCenter.different_markers_color
            ? "on"
            : "",
        marker_out_color: this.qrDesign.QrMarkOut.main,
        marker_top_right_outline: this.qrDesign.QrMarkOut.topRight,
        marker_top_right_center: this.qrDesign.MarkerCenter.topRight,
        marker_bottom_left_outline: this.qrDesign.QrMarkOut.bottomLeft,
        marker_bottom_left_center: this.qrDesign.MarkerCenter.bottomLeft,
        custom_frame_color: this.qrDesign.QrFrame?.different_markers_color
          ? "on"
          : "",
        outer_frame: this.qrDesign.QrFrame.framePattern,
        framecolor: this.qrDesign.QrFrame.main,
        framelabel: this.qrDesign.QrFrame.text,
        optionlogo: this.qrDesign.LogoImg.logoImg,
        no_logo_bg: this.qrDesign.LogoImg.noBg ? "on" : "",
        "logo-size": this.qrDesign.LogoImg.logoSize,
        label_font: "AbrilFatface.svg",
        "label-text-size": "100",
        size: "248",
        level: "H",
      };
    },
  },

  mounted() {
    this.setKeys(this.cardTexts);

    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.cardTexts.gallery[0].images[0].url = this.imageurl_1;
    this.cardTexts.gallery[0].images[1].url = this.imageurl_2;
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    this.qrDesign = {
      qrStyleColors: {
        backcolor: "",
        frontColor: "",
        gradient_color: "",
        gradient: false,
        pattern: "default",
      },
      MarkerCenter: {
        topRight: "",
        bottomLeft: "",
        main: "",
        different_markers_color: false,
        eyePattern: "default",
      },
      QrMarkOut: {
        topRight: "",
        bottomLeft: "",
        markOutPattern: "default",
        main: "",
        different_markers_color: false,
      },
      QrFrame: {
        main: "",
        text: "SCAN ME",
        framePattern: "none",
        different_markers_color: false,
      },
      LogoImg: { noBg: false, logoSize: 100, logoImg: "none" },
    };

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
    Bus.$on("colorPalette", (value) => {
      this.cardTexts.photo.color = value;
    });

    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
